import { Component, Inject, OnInit } from '@angular/core';
import { CustdispositionService } from '../../campaigns/campaign.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
// import { log } from 'console';

@Component({
  selector: 'app-disposition-details',
  templateUrl: './disposition-details.component.html',
  styleUrls: ['./disposition-details.component.css']
})
export class DispositionDetailsComponent implements OnInit {
  InUDispositions: any[];
  dispoData: any;
  fieldArray: any;
  StoreID: any = [];
  replaceData: any = [];
  theunique: any = [];
  activedispoids: any = [];
  alldisposition:any=[];
  setDispo:any=[];
  campaign_id:any=[];
  finalDispo:any=[];
  Dispoidonly:any=[];
  DispoData:any=[];

  statusdata1:any=[];
  statusid1:any=[];
  statusdata01:any=[];
  statusid01:any=[];
  arraynew: any = [];
  stringnew:string;
  uniqueData:any=[];
  newARRAy:any=[];
  disposition_id:any=[];
  lastData:any=[];

  constructor(private route: ActivatedRoute,protected msg: MatSnackBar, protected cusDis: CustdispositionService, @Inject(MAT_DIALOG_DATA) public data1: any, private dialogRef: MatDialogRef<DispositionDetailsComponent>) { }

  ngOnInit() {
    this.InUDispositions = []
    this.fieldArray = []
    this.StoreID = this.data1
    console.log("first", this.data1,typeof this.data1['dispoGroupID']);
    if(this.data1.campid>0){
      this.campaign_id=this.data1.campid;
    }else{
      this.campaign_id=0;
    }
    if (typeof this.data1['dispoGroupID'] !== 'undefined' && this.campaign_id>0) {
      console.log("check in top if ::::===>");
      this.setDispo=this.data1.dispos;
      this.data1.dispos.forEach((item) => {
        this.activedispoids.push(item.disposition_id)
      })
      console.log(this.activedispoids)
      if(this.campaign_id>0){
       this.getDataoneditCampaign(this.data1);
      }else{
        this.cusDis.getService(this.data1['dispoGroupID']).subscribe(res => {
          console.log("get result here ::::===>",res);
          res.forEach((item) => {
            // console.log(this.activedispoids.includes(item.id), item.id)
            if (this.activedispoids.includes(item.id)) {
              this.fieldArray.push({ abbr: item.abbr, label: item.label, id: item.id, status: 1 });
              this.finalDispo.push({ abbr: item.abbr, label: item.label, id: item.id, status: 1 });
              if(item.status==1){
                this.alldisposition.push(item.id);
              }
            } else {
              this.fieldArray.push({ abbr: item.abbr, label: item.label, id: item.id, status: 0 });
              this.finalDispo.push({ abbr: item.abbr, label: item.label, id: item.id, status: 0 });
              if(item.status==1){
                this.alldisposition.push(item.id);
              }
            }
          })
        })
      }
    } else {
      console.log("check in bottom else ::::===>");
      this.cusDis.getService(this.data1['dispoGroupID']).subscribe(res => {
        console.log("disposition data :::===>",res);
        res.forEach((item) => {
          this.fieldArray.push({ abbr: item.abbr, label: item.label, id: item.id, status:item.status });
          this.finalDispo.push({ abbr: item.abbr, label: item.label, id: item.id, status:item.status });
          this.DispoData.push({ abbr: item.abbr, label: item.label, id: item.id,cstatus:item.status });
          if(item.status==1){
            this.alldisposition.push(item.id);
          }
        })
      }) 
    }
  }
  close() {
    if(this.uniqueData.length>0){
      const dataToSend = {
        data1:this.alldisposition ,
        data2: this.uniqueData,
       }
    this.dialogRef.close(dataToSend);
      }else if(this.theunique.length>0){
        const dataToSend = {
          data1:this.alldisposition ,
          data2: this.lastData,
          }
        this.dialogRef.close(dataToSend);
    
    }else{
      const dataToSend = {
        data1:this.alldisposition ,
        data2: this.finalDispo,
        }
      this.dialogRef.close(dataToSend);
    }
  }

  getDataoneditCampaign(data:any){
    let record=[];
    this.cusDis.getDispocamp(JSON.stringify(data)).subscribe((res:any) => {
      console.log("get result",res);
      if(res.result.length>0){
        record=res.result;
        record.forEach((item) => {
          this.finalDispo.push({ abbr: item.abbr, label: item.label, id: item.id, status:item.status});
          this.uniqueData.push({ abbr: item.abbr, label: item.label, id: item.id, status:item.status});
          // if(item.status==1){
            this.alldisposition.push(item.id);
          // }
        })
        var mergedArray = [...res.result, ...res.result1];
        this.fieldArray= mergedArray.filter((obj, index, self) =>
            index === self.findIndex((o) => o.id === obj.id)
          );
      }else{
      console.log("or checking here :::::::***");
        this.cusDis.getService(this.data1['dispoGroupID']).subscribe(res => {
          res.forEach((item) => {
            console.log(this.activedispoids.includes(item.id), item.id)
              this.fieldArray.push({ abbr: item.abbr, label: item.label, id: item.id, status:item.status});
              if(item.status==1){
                this.alldisposition.push(item.id);
                this.finalDispo.push({ abbr: item.abbr, label: item.label, id: item.id, status: item.status });
              }
          })
        })
        
      }
    
    }) 
  }

  QuickchangeStatus(e: any, dispoid: number,i:number) {
    console.log("check event :::",e);
    console.log();
    this.disposition_id.push(dispoid);
    
    if (e == true) {
        this.replaceValueById(this.fieldArray,dispoid,1,e,i);
    }else{
      console.log("getting index here ::::=>",dispoid,i);
      if(this.uniqueData.length>0){
        var index=this.uniqueData.map(x => {
          return x.id;}).indexOf(dispoid);
        this.uniqueData.splice(index,1);
        console.log("data after slice",this.uniqueData);
      }else{
        this.replaceValueById(this.fieldArray,dispoid,0,e,i);
      }
    }
  }

  filterData(recdata:any,arrdata:any){
      this.theunique = arrdata.filter(el => {
         return recdata.find(element => {
            return element === el.id ;
         });
      });
      console.log("test data",this.theunique);
  }
  replaceValueById(alData: any, idDispo: number, statusval: number,event:Boolean,ind:number) {
    console.log(alData,"checking for data ::::+++>",event);
    var newdata = alData.map(obj => {
      if (obj.id === idDispo) {
        return { ...obj, status: statusval };
      }
      return obj;
    });
    console.log("on chage status:::",newdata);
    
    if(event==true){
      var status1data = newdata.filter(function (element) {
        return element.status == 1;
      });
          // this.theunique=ndata; 
          console.log("status data :::",status1data);

           this.theunique.push(...status1data);
          console.log("checking data :::RTRT",status1data);
          console.log("getting result here :::=>",newdata);
          console.log("replace data", this.theunique);
          this.uniqueData=this.removeDuplicates(this.theunique)
          console.log("final unique data", this.uniqueData);
    }else{
        var status1data = newdata.filter(function (element) {
          return element.status == 1;
        });
            console.log("disposition_idies", this.disposition_id);
            const resultData = alData.filter(item => !this.disposition_id.includes(item.id));
            this.lastData=resultData
            console.log( this.lastData,"Last disposition data");
            
            console.log("test result ::",resultData);
            console.log("test log here ::::",status1data);
            this.theunique.push(...status1data);
            console.log("checking data :::RTRT",status1data);
            console.log("getting result here :::=>",newdata);
            console.log("replace data for testing here :::%^%^%", this.theunique);
    }

          
  }
  removeDuplicates(arr) {
    const uniqueIds = new Set();
    return arr.filter(obj => {
      if (!uniqueIds.has(obj.id)) {
        uniqueIds.add(obj.id);
        return true;
      }
      return false;
    });
  }

  openSnackBar(message: string, action: string) {
    this.msg.open(message, action, {
      duration: 3000
      , verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['snackbarwarn']
    });
  }

}